import * as React from 'react'

function IconLeaf5(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={62}
      height={53}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.767 39.662l47.962-27.964L2.062 52.66s56.915 7.136 59.23-50.323c.014.012-57.326-13.7-60.525 37.325z"
        fill="#F4BA27"
      />
    </svg>
  )
}

export default IconLeaf5
